import * as types from '../../index';

export const aflt_appayrateListAction = (data) => {
    return {
    type: types.APPAYRATE_LIST_AFFILIATE,
    data
    }
};

export const aflt_appayrateAddAction = (data) => {
    return {
    type: types.APPAYRATE_ADD_AFFILIATE,
    data
    }
};

export const aflt_appayrateUpdateAction = (data) => {
    return {
    type: types.APPAYRATE_UPDATE_AFFILIATE,
    data
    }
};

export const aflt_appayrateDeleteAction = (data) => {
    return {
    type: types.APPAYRATE_DELETE_AFFILIATE,
    data
    }
};